import React, { Fragment } from 'react'
import { GAME_DESCRIPTION } from './CUSTOM_RULES_CONTENT'

export default function GameDescription() {
  return (
    <Fragment>
      <h3>{GAME_DESCRIPTION.title}</h3>
      <p>{GAME_DESCRIPTION.description}</p>
    </Fragment>
  )
}
